import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnSizeFormatted } from "@/lib/globalFormatterHelper";
import { getFillQuantityFromStore } from "./fillQuantityHelpers";

/**
 * Format value only (for copy/paste - NO notation symbols)
 *
 * @param quantity - The fill quantity value
 * @returns Formatted string with value and trailing space
 */
export function formatFillQuantityValue(
  quantity: number | null | undefined,
): string {
  if (quantity === null || quantity === undefined) {
    return "";
  }

  return `${quantity} `;
}

/**
 * Format with notation for display (MM/M format)
 *
 * @param quantity - The fill quantity value
 * @param instrumentType - Optional instrument type for special formatting (e.g., "FUT" for lots)
 * @returns Formatted string for display (e.g., "12 MM", "500 M", "100 lots")
 */
export function formatFillQuantityWithNotation(
  quantity: number | null | undefined,
  instrumentType?: string,
): string {
  if (quantity === null || quantity === undefined) {
    return "";
  }

  return returnSizeFormatted(quantity, instrumentType);
}

/**
 * AG Grid valueFormatter for copy/paste functionality.
 * Accesses Zustand store directly for current values.
 *
 * @param params - AG Grid cell params
 * @returns Formatted string for copy/paste
 */
export function fillQuantityValueFormatter(params: any): string {
  if (!params.data) {
    return "";
  }

  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const esid = fullTradeData?.esid;

  if (!esid) {
    // Fallback to params.value if we can't get trade data
    return params.value !== null && params.value !== undefined
      ? `${params.value} `
      : "";
  }

  const fillId = params.data.fillId;
  const blockId = params.data.blockId;

  // Get fresh value from Zustand store
  const quantity = getFillQuantityFromStore(esid, fillId, blockId);

  // If we couldn't get from store, fallback to params.value
  if (quantity === null) {
    return params.value !== null && params.value !== undefined
      ? `${params.value} `
      : "";
  }

  return formatFillQuantityValue(quantity);
}
